// ── Helper de FECHAS por idioma (F0 bilingüe) ────────────────────────────────
// Hoy hay decenas de toLocaleDateString('es-ES') hardcodeados por el frontal.
// A partir de F0, TODO formateo de fecha de cara al cliente pasa por aquí:
// el locale sale del idioma activo de i18n (es→es-ES, ca→ca-ES) y añadir un
// idioma nuevo es una línea en LOCALES. Migración de los call-sites: mecánica,
// por fases (F2/F3), pantalla a pantalla junto a su extracción de textos.
import i18n from './index';

const LOCALES = { es: 'es-ES', ca: 'ca-ES' };

export const localeActual = () => LOCALES[i18n.language] || LOCALES.es;

// Fecha corta: 14/7/2026 (es) · 14/7/2026 (ca)
export const formatearFecha = (fecha, opciones) =>
  new Date(fecha).toLocaleDateString(localeActual(), opciones);

// Fecha larga: 14 de julio de 2026 (es) · 14 de juliol de 2026 (ca)
export const formatearFechaLarga = (fecha) =>
  formatearFecha(fecha, { day: 'numeric', month: 'long', year: 'numeric' });

// Día y hora: 14/7/2026, 21:30
export const formatearFechaHora = (fecha) =>
  new Date(fecha).toLocaleString(localeActual(), {
    day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit',
  });
